"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var CUSTPROP_TYPES = _interopRequireWildcard(require("../../constants/customProperties"));
var _hooks = require("../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  REFDATA_CLASS_NAME: REFDATA,
  MULTI_REFDATA_CLASS_NAME: MULTIREFDATA,
  DECIMAL_CLASS_NAME: DECIMAL,
  INTEGER_CLASS_NAME: INTEGER,
  DATE_CLASS_NAME: DATE,
  TEXT_CLASS_NAME: TEXT
} = CUSTPROP_TYPES;
const useOperators = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let passedIntlKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let passedIntlNS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let labelOverrides = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const operators = [{
    value: ' isSet',
    label: kintIntl.formatKintMessage({
      id: 'operator.isSet',
      overrideValue: labelOverrides.operatorIsSet
    }),
    noValueAllowed: true
  }, {
    value: ' isNotSet',
    label: kintIntl.formatKintMessage({
      id: 'operator.isNotSet',
      overrideValue: labelOverrides.operatorIsNotSet
    }),
    noValueAllowed: true
  }];
  if (!type || type === INTEGER || type === DECIMAL) {
    operators.push({
      value: '==',
      label: kintIntl.formatKintMessage({
        id: 'operator.equals',
        overrideValue: labelOverrides.operatorEquals
      })
    }, {
      value: '!=',
      label: kintIntl.formatKintMessage({
        id: 'operator.doesNotEqual',
        overrideValue: labelOverrides.operatorDoesNotEqual
      })
    }, {
      value: '>=',
      label: kintIntl.formatKintMessage({
        id: 'operator.isGreaterThanOrEqual',
        overrideValue: labelOverrides.operatorIsGreaterThanOrEqual
      })
    }, {
      value: '<=',
      label: kintIntl.formatKintMessage({
        id: 'operator.isLessThanOrEqual',
        overrideValue: labelOverrides.operatorIsLessThanOrEqual
      })
    });
  }
  if (type === DATE) {
    // Basically the same as the "number" types above, so no need to reassign if there is no type
    operators.push({
      value: '==',
      label: kintIntl.formatKintMessage({
        id: 'operator.equals',
        overrideValue: labelOverrides.operatorEquals
      })
    }, {
      value: '!=',
      label: kintIntl.formatKintMessage({
        id: 'operator.doesNotEqual',
        overrideValue: labelOverrides.operatorDoesNotEqual
      })
    }, {
      value: '>=',
      label: kintIntl.formatKintMessage({
        id: 'operator.isOnOrAfter',
        overrideValue: labelOverrides.operatorIsOnOrAfter
      })
    }, {
      value: '<=',
      label: kintIntl.formatKintMessage({
        id: 'operator.isOnOrBefore',
        overrideValue: labelOverrides.operatorIsOnOrBefore
      })
    });
  }
  if (!type || type === REFDATA) {
    operators.push({
      value: '==',
      label: kintIntl.formatKintMessage({
        id: 'operator.is',
        overrideValue: labelOverrides.operatorIs
      })
    }, {
      value: '!=',
      label: kintIntl.formatKintMessage({
        id: 'operator.isNot',
        overrideValue: labelOverrides.operatorIsNot
      })
    });
  }
  if (type === MULTIREFDATA) {
    operators.push({
      value: '==',
      label: kintIntl.formatKintMessage({
        id: 'operator.contains',
        overrideValue: labelOverrides.operatorContains
      })
    });
  }
  if (!type || type === TEXT) {
    operators.push({
      value: '=~',
      label: kintIntl.formatKintMessage({
        id: 'operator.contains',
        overrideValue: labelOverrides.operatorContains
      })
    }, {
      value: '!~',
      label: kintIntl.formatKintMessage({
        id: 'operator.doesNotContain',
        overrideValue: labelOverrides.operatorDoesNotContain
      })
    });
  }
  return operators;
};
var _default = exports.default = useOperators;